/**
 * Returns the correct series IDs based on whether the app
 * is running on a staging URL (contains "manningtonstaging").
 */

const isStaging = window.location.href.includes("manningtonstaging");

export const SERIES_IDS = {
  carpet: isStaging ? 9770 : 8639,
  lvt: isStaging ? 9771 : 8645,
  broadloom: isStaging ? 9773 : 9743,
  heterogeneous: 8644,
  homogeneous: 8643,
  installMethods: 9774,
  wallColors: 7973,
};

// Detect square-shaped tile products from the `warranty` column
// (which the data feed uses to encode nominal dimensions like "18x18",
// "24x24", or "17.7x17.17"). Returns true when width ≈ height within
// 10% tolerance — square tiles need an extra 90° rotation applied both
// on product thumbs and on the applied scene SEL.
export const isSquareProduct = (product) => {
  const w = String(product?.warranty || '');
  const m = /^\s*([\d.]+)\s*x\s*([\d.]+)\s*$/i.exec(w);
  if (!m) return false;
  const a = parseFloat(m[1]);
  const b = parseFloat(m[2]);
  if (!isFinite(a) || !isFinite(b) || a <= 0 || b <= 0) return false;
  return Math.abs(a - b) / Math.max(a, b) < 0.1;
};
